import { createAsyncThunk } from '@reduxjs/toolkit';

import { StatementService } from 'api';

import { StatementData } from 'models';

export const getInvestment = createAsyncThunk(
	'statement/getInvestment',
	async (data: StatementData) => {
		return await StatementService.getInvestment(data);
	},
);
